import type { Translatable } from "app/pages/sales-intelligence/types";

export const SELECTION_MODAL_TITLE: Translatable = {
    key: "si.components.lists_results_table.column_picker.title",
};
